/**
 * @author Victor Andrade <victor.andrade@caixamagica.pt>
 *
 * @description Componente que tem como funcionalidade apresentar apresentar uma alerta de espera ao utilizador
 *
 * @version 20210226
 * @since 20210226 Initial release
 *
 */

import { memo } from 'react';
import { Dialog } from '@effizency/efz-design-system';

import IntlMessages from 'components/util/IntlMessages';

import { StyledLoadingDialogSubtitle } from './index.styled';

interface ILoadingDialogProps {
    isOpen: boolean;
    title: string;
    subtitle?: string;
}

// Without onClose, neither the backdrop nor Escape closes it.
const LoadingDialog = ({ isOpen, title, subtitle }: ILoadingDialogProps) => (
    <Dialog
        loadingDialog
        open={isOpen}
        dataTestId="loading-dialog"
        title={
            <>
                <IntlMessages id={title} />
                {!!subtitle && (
                    <StyledLoadingDialogSubtitle>
                        <IntlMessages id={subtitle} />
                    </StyledLoadingDialogSubtitle>
                )}
            </>
        }
    />
);

export default memo(LoadingDialog);
